import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Navigation } from '../../navigation/react-redux-nav';
import Icon, { NAMES } from '@ifit/react-icons';
import MuiRaisedButton from 'material-ui/RaisedButton';
import SuccessModal from './components/success-modal';
import { TextField as MuiTextField } from 'redux-form-material-ui';
import { shark, scienceBlue } from '../../theme/colors';
import styles from '../../shared-styles';
import { getActivationCode, redeemActivationCode } from '../../store/ducks/payment';

import './index.css';

export class ActivationCodePage extends Component {
  constructor(props) {
    super(props);

    this.state = { redeemed: false };
  }

  submitForm = async (values) => {
    try {
      const { value: { activationCodeItems, includesWearable } } = await this.props.getActivationCode(values.activationCode);
      if (includesWearable) {
        this.props.goToShippingAddress();
      } else {
        await this.props.redeemActivationCode(values.activationCode, activationCodeItems);
        this.setState({
          redeemed: true
        });
      }
    } catch (err) {
      throw new SubmissionError({ activationCode: err.message });
    }
  }

  handleSubmit = this.props.handleSubmit(this.submitForm);

  render() {
    return (
      <div className="activation-page">
        <Navigation.Backward>
          <Icon
            className="back-arrow-icon"
            name={ NAMES.ARROW_LEFT }
            color={ shark }
            size={ 24 }
            unitSize="px"
          />
        </Navigation.Backward>
        { this.renderActivationInput() }
      </div>
    );
  }

  renderActivationInput() {
    return (
      <form onSubmit={ this.handleSubmit }>
        <h1>Redeem activation or promo code</h1>
        <Field
          type="search"
          name="activationCode"
          component={ MuiTextField }
          className="form-field"
          hintText="ACVF-GFFV-DOJE-GVYR"
          floatingLabelText="Enter Code"
          fullWidth={ true }
          errorStyle={ styles.errorStyle }
          inputStyle={ styles.textStyle }
          hintStyle={ styles.textStyle }
          floatingLabelFocusStyle={{ color: scienceBlue }}
          underlineFocusStyle={{ borderColor: scienceBlue }}
          autoCapitalize="off"
          autoFocus
        />

        <MuiRaisedButton
          className="redeem-button button"
          type="submit"
          label="Redeem"
          primary={ true }
          fullWidth={ true }
          style={ styles.buttonStyle }
          buttonStyle={ styles.buttonBorderStyle }
          labelStyle={ styles.buttonLabelStyle }
        />
        <SuccessModal
          open={ this.state.redeemed }
        />
      </form>
    );
  }
}

ActivationCodePage.propTypes = {
  getActivationCode: PropTypes.func.isRequired,
  redeemActivationCode: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  goToShippingAddress: PropTypes.func.isRequired
};

export default connect(
  null,
  dispatch => ({
    getActivationCode: code => dispatch(getActivationCode(code)),
    redeemActivationCode: (code, items) => dispatch(redeemActivationCode(code, items)),
    goToShippingAddress: () => dispatch(Navigation.jumpTo('shipping-address'))
  })
)(
  reduxForm({
    form: 'activation-page'
  })(ActivationCodePage)
);
